import { Component, OnInit, OnDestroy } from '@angular/core';
import { BeeFreeService } from '../../services/beefree.service';
import { Router } from '@angular/router';
import { MaintenanceService } from '../../services/maintenance.service';
import { OverlayService } from '../../services/overlay.service';
import { interval, EMPTY, Subscription } from 'rxjs';
import { switchMap, startWith, catchError } from 'rxjs/operators';
import { NewApiHttpService } from '../../services/new-api-http.service';
import { AuthService } from '../../services/auth.service';

@Component({
	selector: 'app-maintenance',
	templateUrl: './maintenance.component.html',
	styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit, OnDestroy {
	isBeeFree: boolean;
	checkServer: Subscription;

	constructor(
		private maintenance: MaintenanceService,
		private beeFree: BeeFreeService,
		private overlay: OverlayService,
		private router: Router,
		private newApiHttpService: NewApiHttpService,
		private auth: AuthService
	) {}

	ngOnInit() {
		this.isBeeFree = this.beeFree.isBeeFreeAddon();
		this.overlay.updateOverlay(false);

		this.maintenance.setMaintenancePage(false);
		this.router.navigate(['/']);

		// if (this.auth.getUser()) {
		// 	this.checkServer = interval(5 * 60 * 1000)
		// 		.pipe(
		// 			startWith(0),
		// 			switchMap(() =>
		// 				this.newApiHttpService.newApiRequestGet('', {}).pipe(
		// 					catchError((error) => {
		// 						if (error == 'Server Maintenance') {
		// 							this.maintenance.setMaintenancePage(true);
		// 						}
		// 						return EMPTY;
		// 					})
		// 				)
		// 			)
		// 		)
		// 		.subscribe((response) => {
		// 			if (response && response.status) {
		// 				this.maintenance.setMaintenancePage(false);
		// 				this.router.navigate(['/']);
		// 			}
		// 		});
		// } else {
		// 	if (!this.maintenance.inMaintenance()) {
		// 	}
		// }
	}

	ngOnDestroy() {
		if (this.checkServer) {
			this.checkServer.unsubscribe();
		}
	}

	cancelBeeFree() {
		this.beeFree.cancelAddon();
	}
}
